module.exports = __webpack_public_path__ + "static/media/cashier.f5cf4712.png";